export const handleApiError = (
  error: any,
  notify: (message: string, status: string) => void,
  fallbackMessage = 'An unexpected error occurred.'
) => {
  if (error?.request?.status === 400 || error?.request?.status === 409) {
    var errorData = error?.response?.data;
    var errorMessage = fallbackMessage;
    if (errorData?.errors)
      errorMessage = Object.values(errorData?.errors)
        .map((arr: any) => arr.join('\n'))
        .reduce((acc, curr) => acc + '\n' + curr, '');
    else if (typeof errorData?.detail === 'string')
      errorMessage = errorData.detail;

    notify(errorMessage, 'error');
  } else {
    // eslint-disable-next-line no-console
    console.log(error);
    throw error;
  }
};
